import { useEffect, useState } from 'react';
import { paramCase } from 'change-case';
import { useParams, useLocation } from 'react-router-dom';
// material
import { Container } from '@mui/material';
// redux
import { useDispatch, useSelector, RootState } from '../../../redux/store';
import { getUserList } from '../../../redux/slices/user';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
import { Link as RouterLink, Navigate } from 'react-router-dom';
// hooks
import useSettings from '../../../hooks/useSettings';
// components
import Page from '../../../components/Page';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import UserNewForm from '../../../components/_dashboard/user/UserNewForm';
import useAuth from '../../../hooks/useAuth';
import ContactCreateForm from 'components/_dashboard/contact/ContactNewForm';
import { axios } from 'utils/axios';
// ----------------------------------------------------------------------

export default function ContactCreate() {
  const { themeStretch } = useSettings();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { id = '' } = useParams();
  const [contactInfo, setContactInfo] = useState<any>({});
  const isEdit = pathname.includes('edit');
  const isDetails = pathname.includes('details');
  // const currentUser = userList.find((user) => paramCase(user.userID) === id);
  const [redirect, setRedirect] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    if (user?.role !== 'admin') {
      setRedirect(true);
    }
    if (!isEdit) {
      setContactInfo({});
    }
    fetchContactInfo();
  }, [isEdit]);

  const fetchContactInfo = async () => {
    const response = await axios.get(`/rest/api/contacts/info/${id}`);
    setContactInfo(response.data.data.data);
  };
  useEffect(() => {
    dispatch(getUserList());
  }, [dispatch]);
  function redirectTo() {
    return <Navigate to="/dashboard/inspections" />;
  }

  if (redirect) return redirectTo();
  return (
    <Page title={`Contact: ${isEdit ? 'Edit' : isDetails ? 'Details' : 'Create'} a Contact`}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={isDetails ? 'Contact Details' : isEdit ? 'Edit Contact' : 'Create a New Contact'}
          links={[
            { name: 'Dashboard', href: '/dashboard' },
            { name: 'Contacts', href: '/dashboard/contacts' },
            { name: isDetails ? 'Details' : isEdit ? 'Edit' : 'New Contact' }
          ]}
        />
        <ContactCreateForm isEdit={isEdit} isDetails={isDetails} currentUser={contactInfo} />
      </Container>
    </Page>
  );
}
